import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleSubmit } from "../../Controller/UpdatePartBOMController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PartService from "../../Controller/PartController";
import 'datatables.net-bs5';
import $ from 'jquery';


function UpdateStockLocationBOM({ onClose, onSuccess, StockID, stockSelectedID, BOMID }) {
  
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        bomID: BOMID,
        stockSelectedID: stockSelectedID
    });
    const [selectedRow, setSelectedRow] = useState(null); // State to keep track of selected row
    const [selectedRowIndex, setSelectedRowIndex] = useState(null); // State to keep track of selected row index
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [StockLocationList, setStockLocation] = useState([]);
    const tableRef = useRef();
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
   
    // Debugging log to check initial state
    useEffect(() => {
        console.log('Initial BOMID:', BOMID);
        console.log('Initial formData:', formData);
    }, [BOMID, formData]);

    useEffect(() => {
        fetchStockLocations(stockSelectedID);
    }, [stockSelectedID]);

    useEffect(() => {
        if (tableRef.current && StockLocationList.length > 0) {
            $(tableRef.current).DataTable();
        }
    }, [StockLocationList]);
    
    const fetchStockLocations = async (stockSelectedID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, stockSelectedID);
            setStockLocation(listOfLocations);
            return listOfLocations; // Return the list of locations
        } catch (error) {
            console.error('Error fetching locations:', error);
            return []; // Return an empty array in case of an error
        }
    };

    const handleFormSubmit = async (event) => {
      
        event.preventDefault();
        if (!selectedRow) {
            alert("Please select a row to submit");
            return;
        }

        const updatedFormData = {
            ...formData,
            StockLocationID: selectedRow.PK_StockLocation_ID,
            bomID:BOMID
        };

        // Debugging log to check formData before submit
        console.log('Form data before submit:', updatedFormData);

        const redirectCallback = () => {
            navigate('/');
        };

        try {
            handleSubmit(event, updatedFormData, setFormData, setErrors, () => {
                onSuccess(); // Call onSuccess to reload data
                
            }, () => {
                onSuccess(); // Call onSuccess to reload data
                
            });
        } catch (error) {
            console.error('Error fetching stock locations or submitting form:', error);
        }
    };

    const handleRowSelect = (part, index) => {
        setSelectedRow(part);
        setSelectedRowIndex(index);
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
            <div className="modal fade stockLocationBOMModal show d-block" id="stockLocationBOMModal" tabIndex="-1" aria-labelledby="stockLocationBOMModalLabel" aria-hidden="true" data-backdrop="static">
                
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Create BOM</h5>
                                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                            <table className="table datatable table-bordered" style={{ "width": "98%","marginLeft":"0px","marginRight":"10px","marginTop":"10px" }}>
                                    <thead>
                                        <tr>
                                            <th>Depots</th>
                                            <th>Location</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {StockLocationList.map((part, index) => (
                                            <tr
                                                key={part.PK_StockLocation_ID}
                                                onClick={() => handleRowSelect(part, index)}
                                                className={selectedRowIndex === index ? 'table-primary' : ''}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <td>{part.vc_Name}</td>
                                                <td>{part.vc_BayName}</td>
                                                <td>{part.dec_Quantity}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">{t('submit')}</button>
                                
                                <button type="button" className="btn btn-secondary" aria-label="Close" onClick={onClose}>
                                Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default UpdateStockLocationBOM;
